import { BaseService } from '@shared/base/Base.Service';
import { Directive } from "@angular/core";

@Directive()
export abstract class EmBaseService extends BaseService {
}
